import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';

@Injectable({
  providedIn: 'root'
})
export class ExpressAccountingService extends ConnectionService {

  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
  }

  
  GetQRPaymentLink(requestBody, sucFun, errFun) {
    var endPoint = this.configs.getAppApiUrl("QR_PAYMENT_LINK").replace("myoutlet/v1", "McApiNew/api");
    this.CallApi('post', endPoint, requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }
}
